<div [ngClass]="compact() ? 'w-full mb-1' : 'w-full mb-3 md:mb-6'">
  
  @if (status() !== 'valid') {
    <div class="flex gap-1.5 w-full">
      <input 
        type="text" 
        [ngModel]="code()" 
        (ngModelChange)="code.set($event.toUpperCase())"
        [placeholder]="'::EnterCouponPlaceholder' | abpLocalization" 
        [disabled]="status() === 'validating'"
        (keyup.enter)="applyCoupon()"
        [ngClass]="[
          'flex-1 min-w-0 px-3 rounded-xl bg-[#F2EFEE] border-none text-sm placeholder:italic placeholder:text-gray-400 focus:outline-none focus:ring-0 uppercase placeholder:normal-case',
          compact() ? 'h-9' : 'h-10 md:h-12'
        ]"
      />
      <button 
        (click)="applyCoupon()"
        [disabled]="!code().trim() || status() === 'validating'"
        [ngClass]="[
          'px-3 bg-[#0D171C] text-white font-bold rounded-xl whitespace-nowrap transition-all active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed shrink-0',
          compact() ? 'h-9' : 'h-10 md:h-12'
        ]"
      >
        @if (status() !== 'validating') {
          <span>{{ '::Apply' | abpLocalization }}</span>
        } @else {
          <div class="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
        }
      </button>
    </div>
  }

  @if (status() === 'valid' && appliedCoupon()) {
    <!-- Refined Final Premium Success State -->
    <div [ngClass]="[
      'flex items-center bg-[#f0f9f4] border border-green-200/60 pl-3 pr-2 rounded-2xl w-full shadow-sm animate-in fade-in slide-in-from-top-1 duration-300',
      compact() ? 'h-10' : 'h-14'
    ]">
      <!-- Left: Check Circle (Perfectly Centered) -->
      <div class="flex items-center justify-center w-8 h-8 rounded-full bg-green-100/50 border border-green-100 shrink-0 overflow-hidden">
        <span class="w-5 h-5 text-[#108548] flex items-center justify-center" [innerHTML]="icons.check"></span>
      </div>
      
      <!-- Divider -->
      <div class="h-6 w-[1px] bg-green-200/60 shrink-0 mx-2.5"></div>
      
      <!-- Middle: Tag + Text Stack (Closer to Divider) -->
      <div class="flex-1 flex items-center gap-1.5 min-w-0">
        <!-- Tag Icon (Vertically Centered) -->
        <span class="w-6 h-6 shrink-0 flex items-center justify-center text-[#108548]" [innerHTML]="icons.tag"></span>
        
        <!-- Text Stack -->
        <div class="flex flex-col justify-center min-w-0">
          <span class="text-[9px] uppercase tracking-[0.05em] text-[#108548] font-bold leading-tight opacity-80 whitespace-nowrap">
            {{ '::CouponApplied' | abpLocalization }}
          </span>
          <span class="text-sm font-bold text-[#108548] whitespace-nowrap leading-tight">
            {{ appliedCoupon()?.coupon?.discountType === 0 ? appliedCoupon()?.coupon?.discountValue + '%' : appliedCoupon()?.coupon?.code }}
            <span class="font-medium text-[11px] ml-0.5">{{ '::DiscountOff' | abpLocalization }}</span>
          </span>
        </div>
      </div>
      
      <!-- Right: Close Button (Perfectly Centered) -->
      <button 
        (click)="removeCoupon()"
        class="w-9 h-9 flex items-center justify-center rounded-xl bg-white border border-green-100 text-[#108548] hover:text-red-500 hover:border-red-100 transition-all shadow-sm shrink-0 ml-1"
      >
        <span class="w-4 h-4 flex items-center justify-center" [innerHTML]="icons.close"></span>
      </button>
    </div>
  }

  @if (status() === 'invalid') {
    <!-- Error State -->
    <div class="mt-2 text-red-500 text-xs font-medium flex items-center gap-1.5 px-1">
      {{ errorMessage() }}
    </div>
  }
</div>
